/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {StyleSheet} from 'aphrodite/no-important';

const styles = StyleSheet.create({
	actionButton: {
		color: 'inherit !important',
		outline: 'none !important',
		padding: '0px 12px',
		verticalAlign: 'baseline'
	},
	actionButtonEmbedded: {
		padding: '0'
	},
	hidden: {
		opacity: 0,
		transform: ''
	},
	notification: {
		transition: 'opacity 800ms'
	},
	visible: {
		opacity: 1
	}
});

export default styles;
